export default "__VITE_ASSET__BoTwFQbT__"